import { Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'agency-portal-2025';

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (
      event.shiftKey &&
      event.ctrlKey &&
      event.code === 'KeyU' &&
      environment.name === 'staging'
    ) {
      throw new Error('Fake Error caused by hotkeys');
    }
  }
}
